<div class="card">
    <h1>Results</h1>
    <p>Score: {{result.score}}</p>
    <p>{{result.text}}</p>
</div>